import {publishTrackEvent} from "../.."

const TrackFilterViewAll = (filterCategoryName: string) => {
    publishTrackEvent("filter", {
        filter: {
            category: "filter",
            action: "popup",
            label: "view all",
            option: filterCategoryName,
        },
    })
}

export default TrackFilterViewAll
